import consumer from "./consumer"

consumer.subscriptions.create("NotificationsChannel", {
  connected() {
  },

  disconnected() {
  },

  received(data) {
    if (data.content.type == 'tbml_transaction_created') {
      Turbo.visit(`/transactions/${data.content.id}/edit`, { "action":"replace" });
    } else if (data.content.type == 'tbml_transaction_upload_failed') {
      toastr.error('Could not create Transaction from the uploaded file', '', { closeButton: true })
      setTimeout(() => {
        Turbo.visit(`/home/upload_data`, { "action":"replace" });
      }, 3000);
    } else if (data.content.type == 'tbml_transaction_risk_assessed') {
      $(`tr[data-id='${data.content.id}'] td.risk`).html(
        `<i class="fas fa-traffic-light risk-${data.content.risk}" title="${data.content.risk}" data-bs-toggle="tooltip"></i>`
      );
    }
  }
});
